
import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";

import { useNavigate, Link, useLocation, useNavigationType } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import parse from "react-html-parser";
import SessionPopup from "../pages/SessionPopup";
import Loader from "../components/loader";
import Tooltip from '@mui/material/Tooltip'

let { lambda, appname } = window.app

// list position is saved when opening view/edit so coming back returns to the same page
const LIST_POSITION_KEY = "moduleListPosition";
const DEFAULT_POSITION = { page: 1, perPage: 15, search: "" };
const getSavedListPosition = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(LIST_POSITION_KEY));
        return saved?.page && saved?.perPage ? { ...DEFAULT_POSITION, ...saved } : null;
    } catch {
        return null;
    }
};

const ManageTest = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const navigationType = useNavigationType(); // "POP" = browser back/forward
    const [toggle, setToggle] = useState(false);
    const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    // const [sortDirection, setSortDirection] = useState('asc');
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);
    const [usersearch, setUserSearch] = useState("");
    const [searchedFlag, setSearchedFlag] = useState("");
    // from view/edit (Back button or browser back): restore the saved page; from any other menu: page 1
    const [initialPosition] = useState(() => ((state?.restoreListPage || navigationType === "POP") && getSavedListPosition()) || DEFAULT_POSITION);
    const [page, setPage] = useState(initialPosition.page);
    const [perPage, setPerPage] = useState(initialPosition.perPage);
    const [totalRows, setTotalRows] = useState(0);
    // true when the API paged the result; false when it sent every row (table then pages client-side)
    const [serverPaging, setServerPaging] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [activeSearch, setActiveSearch] = useState(""); // search term the loaded rows belong to
    const requestIdRef = useRef(0);


    // const [isLoading, setIsLoading] = useState(false); 
    const {  isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, currentPage, setcurrentPage,
        // data, setData,

        rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity, isRestricted } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    const isHtml = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);

    const stripHtml = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    const decodeHtmlEntities = (str = "") => {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    };

    const DescriptionColumn = {
        name: "Description",
        sortable: true,

        selector: (row) => {
            const value = row?.description || "";
            return isHtml(value) ? decodeHtmlEntities(stripHtml(value)) : decodeHtmlEntities(value);
        },

        cell: (row) => {
            const value = row?.description || "";
            if (!value) return "-";

            const html = isHtml(value);
            const plainText = html ? decodeHtmlEntities(stripHtml(value)) : decodeHtmlEntities(value);

            // Trim display text
            const words = plainText.split(/\s+/);
            const isLong = words.length > 100;
            const displayText = isLong
                ? words.slice(0, 100).join(" ") + "… Read more"
                : plainText;

            // clean <h3> margins
            const cleanedHtml = html
                ? value.replace(/^<h3[^>]*>/i, "").replace(/<\/h3>$/i, "")
                : null;

            // Tooltip content
            const tooltipTitle = html ? (
                <div
                    style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        padding: "10px",
                        fontSize: "12px",
                        lineHeight: "20px",
                    }}
                >
                    {parse(cleanedHtml)}
                </div>
            ) : (
                plainText
            );

            return (
                <Tooltip
                    title={tooltipTitle}
                    placement="right-start"
                    classes={{ tooltip: "my-tooltip-parent" }}
                    PopperProps={{
                        modifiers: [
                            {
                                name: "preventOverflow",
                                options: {
                                    boundary: "viewport",
                                },
                            },
                        ],
                    }}
                >
                    <div
                        style={{
                            maxWidth: "400px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "default",
                            fontSize: "12px",
                            lineHeight: "20px",
                        }}
                    >
                        {displayText}
                    </div>
                </Tooltip>
            );
        },
    };

    const keyForRerender = `${perPage}_${data?.length}`;
    const columns = [
        {
            name: 'Name',
            selector: row => row?.name ?? "",
            sortable: true,
        },
        // {
        //     name: 'Description',
        //     selector: row => parse(row?.description) ?? "",
        //     sortable: true,
        // },
        DescriptionColumn,
        {
            name: 'Type',
            selector: row => parse(row?.type) ?? "",
            sortable: true,
        },
        {
            name: 'Cost',
            selector: row => row?.cost ?? "",
            sortable: true,
        },
        {
            name: 'Created By',
            selector: row => row?.createdBy?.username ?? "",
        },
        {
            name: 'Created on',
            selector: row => row?.created,
            sortable: true,
            cell: (props) => props?.created ? dateFormat(props?.created) : "",
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },

        {
            name: 'Status',
            selector: row => row?.status,
            sortable: true,
        },
        {
            name:

                //  <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>
                'Actions'
            ,
            cell: (props) =>
                //   {

                <div className="d-flex">

                    <a onClick={(e) => handleViewUser(e, props.moduleid)}
                        className='text-success action-button'><i
                            className="mdi mdi-eye font-size-18"></i>  </a>

                    <a onClick={(e) => handleEditUser(e, props.moduleid)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-pencil font-size-18"></i> </a>

                    <a onClick={(e) => handleDeleteUser(e, props.moduleid)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-delete font-size-18"></i> </a>

                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const dateFormat = (created) => {
        const date = new Date(created);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = String(date.getUTCFullYear()).slice(-2);

        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }


    const handlePageChange = (newPage) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (newPage === page) return;
        GetTimeActivity()
        setPage(newPage);
        if (serverPaging) {
            fetchModules({ page: newPage, search: activeSearch, showLoader: false });
        }
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === perPage) return;
        GetTimeActivity()
        setPerPage(newPerPage);
        setPage(1);
        if (serverPaging) {
            fetchModules({ page: 1, perPage: newPerPage, search: activeSearch, showLoader: false });
        }
    };


    useEffect(() => {
        setRoute("user")
        // setActiveMenuId(200003)
        setData([])
        // userActivity();
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc")),
            "projection": "adminmodule"




        };

    }

// console.log('searchedFlagkkkkk',searchedFlag)
// console.log('searchedFlagssss',searchedFlag)
useEffect(() => {
    setUserSearch(initialPosition.search);
    fetchModules({ page: initialPosition.page, perPage: initialPosition.perPage, search: initialPosition.search });
}, []);
    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    // single fetch for the modules list and search
    const fetchModules = ({ page = 1, perPage: size = perPage, search = "", showLoader = true }) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true)
        const token = localStorage.getItem("token")
        // search only matches without projection=adminmodule
        const query = search ? "&search=" + encodeURIComponent(search) : "&projection=adminmodule"
        axios({
            method: 'GET',
            url: lambda + '/moduleInfo?appname=' + appname + query + "&token=" + token + "&paginate=true&pageNumber=" + page + "&pageSize=" + size,
        })
            .then(function (response) {
                // a newer request went out while this one was in flight - drop this response
                if (requestId !== requestIdRef.current) return;

                if (response?.data?.result === "Invalid token or Expired") {
                    setIsLoading(false)
                    setTableLoading(false)
                    setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                } else {
                    const result = response?.data?.result
                    const rows = result?.data ?? []
                    // more rows than asked for = API ignored paging and sent everything
                    const backendPaged = rows.length <= size

                    // page is past the end (e.g. last row on the page was deleted) - step back one page
                    if (backendPaged && rows.length === 0 && page > 1) {
                        setPage(page - 1)
                        fetchModules({ page: page - 1, perPage: size, search, showLoader })
                        return
                    }

                    if (!search) setUser(rows);
                    setData(rows);
                    global.exportExcelData = rows
                    setServerPaging(backendPaged);
                    setTotalRows(backendPaged ? (result?.totalCount ?? rows.length) : rows.length);
                    setActiveSearch(search);

                    setIsLoading(false);
                    setTableLoading(false);
                }
            }).catch((err) => {
                if (requestId !== requestIdRef.current) return;
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
                setTableLoading(false);
            });
    }

    const saveListPosition = () => {
        localStorage.setItem(LIST_POSITION_KEY, JSON.stringify({ page, perPage, search: activeSearch }));
    };





    // const handleSearch = (e, flagggg) => {

    //     // if (flagggg) {
    //     //     setcurrentPage(1);
    //     // }
    //     // setmaxPageNumberLimit(5);
    //     // setminPageNumberLimit(0);
    //     // if (flagggg === "normalsearch") {
    //     //     setSearchedFlag(true)
    //     // }
    //     // setFlag(true)
    //     // if (usersearch === "") {
    //     //     User();
    //     // }
    //     // else {
    //     setIsLoading(true)
    //     const token = localStorage.getItem("token")
    //     const userId = localStorage.getItem("userId")
    //     axios({
    //         method: 'GET',
    //         url: lambda + '/moduleInfo?appname=' + appname + "&search=" + usersearch + "&token=" + token,
    //     })
    //         .then(function (response) {
    //             if (response?.data?.result === "Invalid token or Expired") {
    //                 setIsLoading(false)
    //                 setShowSessionPopupup(true)
    //                 // localStorage.clear();
    //                 // navigate("/")
    //             } else {

    //                 // setUser(response?.data?.result);
    //                 setData(response?.data?.result?.data ?? []);
    //                 global.exportExcelData = response?.data?.result



    //                 setIsLoading(false)
    //             }
    //         }).catch((err) => {
    //             console.log('error', err);
    //             setTableErrMsg(true)
    //             setIsLoading(false);
    //         });
    //     // }
    // }


    const handleSearch = (e, flagggg) => {
        const inputQuery = usersearch;

        // ✅ Empty / whitespace-only validation
        if (inputQuery.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        setPage(1);
        fetchModules({ page: 1, search: inputQuery });
    };


    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };
    const handleAddUser = (e) => {
        localStorage.removeItem(LIST_POSITION_KEY); // after adding, the list opens on page 1
        navigate("/addmodule");
    }

    const handleEditUser = (e, paramuserid) => {
        console.log('paramuserid', paramuserid)
        saveListPosition();
        navigate("/editmodule/" + paramuserid);
    }

    const handleDeleteUser = (e, paramuserid) => {
        setDeleteUserId(paramuserid)
        setDeleteShow(true)
    }

    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }

    const onDeletePopupClose = (e) => {
        setDeleteSuccess(false)
        setDeleteUserId(null)
        fetchModules({ page, search: activeSearch })
    }

    const handleDelete = async (e) => {
        setDeleteShow(false)

        // axios({
        //     method: 'POST',
        //     url: lambda + '/updateLookup?appname=' + appname + '&lookupcode=' + deleteUserId + '&type=Tests'+ '&statusType=delete',
        // })
        //     .then(function (response) {
        //         if (response) {
        //             if (response?.result === "Invalid token or Expired") {
        //                 setShowSessionPopupup(true)
        //             }  else {
        //                 setIsLoading(false);
        //                 setDeleteSuccess(true)
        //                 setToastMessage("User Deleted Successfully")
        //             }
        //         }

        //     });
        try {
            await tmdbApi.moduleDelete(deleteUserId);

            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
    }


    // const handleViewUser = (e, paramuserid) => {
    //     GetTimeActivity()
    //     navigate("/viewmodule/" + paramuserid);
    // }
    const handleViewUser = (e, moduleid) => {
        e.preventDefault();
        saveListPosition();
        window.open(`/viewmodule/${moduleid}`, "_blank");
    };
    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        setPage(1);
        fetchModules({ page: 1 });
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data were found</p>
                </div> </div>
        )
    }
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.name ?? "",
            "USER TYPE": each?.userType ?? "",
            "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "STATUS": each?.status ?? "",

        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        console.log('data22222--->', data)
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows?.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />

                {/* Start right Content here  */}

                <div className="main-content user-management create-case modules-table" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">MODULES</h4>
                                        </div>

                                        <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser}
                                                disabled={isRestricted}
                                                id="add-user-btn">
                                                CREATE MODULE
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> :
                                                <>
                                                    <div className="row mb-2" id="table-header-row">
                                                        <div className="col-sm-4 button-block" id="button-block">
                                                            <div className="dataTables_length" id="datatable-length">

                                                                {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                          onClick={handleExport} id="export-btn">
                          <span className="material-icons">north_east</span>Export
                      </button> */}


                                                            </div>
                                                        </div>
                                                        <div className="col-sm-8">
                                                            <div className="search-box mb-2 d-inline-block" id="search-box">
                                                                <div className="position-relative">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={usersearch}
                                                                        onChange={(e) => handleChange(e)}
                                                                        placeholder="Search by Module"
                                                                        onKeyPress={handleKeypress}
                                                                        id="search-input"
                                                                    />
                                                                    <button
                                                                        className="fill_btn"
                                                                        onClick={(e) => handleSearch(e, "normalsearch")}
                                                                        id="search-btn">
                                                                        <span className="material-icons search-icon">search</span>
                                                                    </button>
                                                                </div>
                                                                <div className="dataTables_length" id="datatable-length-reset">
                                                                    <button
                                                                        className="fill_btn"
                                                                        onClick={clearSearch}
                                                                        id="reset-btn">
                                                                        <span className="material-icons-outlined">sync</span>Reset
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="text-sm-end" id="text-end"></div>
                                                        </div>
                                                    </div>

                                                    <DataTable
                                                        key={keyForRerender}
                                                        columns={columns}
                                                        keyField='_id'
                                                        data={data}
                                                        direction="auto"
                                                        highlightOnHover
                                                        fixedHeaderScrollHeight="300px"
                                                        pagination
                                                        paginationServer={serverPaging}
                                                        responsive
                                                        persistTableHead
                                                        striped
                                                        subHeaderAlign="right"
                                                        defaultSortField="name"
                                                        noDataComponent={customNoRecords()}
                                                        paginationTotalRows={totalRows}
                                                        onChangeRowsPerPage={handlePerRowsChange}
                                                        onChangePage={handlePageChange}
                                                        paginationPerPage={perPage}
                                                        paginationDefaultPage={page}
                                                        paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                        sortFunction={customSort}
                                                        paginationComponentOptions={{
                                                            rowsPerPageText: 'Per page:',
                                                            rangeSeparatorText: 'of',
                                                            noRowsPerPage: false,
                                                            selectAllRowsItem: false,
                                                            selectAllRowsItemText: 'All',
                                                        }}
                                                        progressPending={tableLoading}
                                                        progressComponent={<TableLoader />}
                                                        id="data-table"
                                                    />
                                                </>}


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>


                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => onDeletePopupClose(e)}
                    >
                    </SweetAlert>
                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />


                    <Footer id="footer" />
                </div>





            </div>
            <style>
                {`
                    .user-management .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(2), .user-management .rdt_Table .rdt_TableBody .rdt_TableRow
                    .rdt_TableCell:nth-child(2) {
                            min-width: 17% !important;
                        },
                        .user-management .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell div:first-child {text-align: start;}
                    `}
            </style>
        </>
    );
};

export default ManageTest;